import { createFeatureSelector, createSelector } from '@ngrx/store';

import type { IEmailSettingsState } from './email-settings.reducers';
import * as fromReducer from './email-settings.reducers';

const getEmailSettingsState = createFeatureSelector<IEmailSettingsState>('emailSettings');

export const getEmailSettingsActionState = createSelector(
  getEmailSettingsState,
  fromReducer.getEmailSettingsActionState
);

export const getEmailSettings = createSelector(getEmailSettingsState, fromReducer.getEmailSettings);

export const getChangeEmailSettingsActionState = createSelector(
  getEmailSettingsState,
  fromReducer.getChangeEmailSettingsActionState
);
